/** How close to the bottom, in pixels, the list counts as being at the bottom. */
export const FOLLOW_TOLERANCE_PX = 24

export interface ScrollMetrics {
  scrollTop: number
  scrollHeight: number
  clientHeight: number
}

/** Whether the list should keep following its newest step: true while the reader sits at the bottom, false once they scroll up. */
export function shouldFollow(
  metrics: ScrollMetrics,
  tolerance: number = FOLLOW_TOLERANCE_PX,
): boolean {
  return metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight <= tolerance
}
